import proj4 from 'proj4';
import { get as getProjection} from 'ol/proj.js';
import { register } from 'ol/proj/proj4.js'; // <- correct import

/**
 * Registers a projection with OpenLayers using Proj4, if it is not already registered.
 *
 * @param {string} projectionCode - The EPSG code to register (e.g. "EPSG:4326").
 * @param {Object.<string, string>} [allProjs] - Optional map of projection definitions (e.g. { 'EPSG:4326': '+proj=longlat +datum=WGS84 +no_defs' }).
 */
export default function registerProjection(projectionCode, allProjs = {}) {
  if (
    !projectionCode ||
    typeof projectionCode !== 'string' ||
    projectionCode.trim() === '' ||
    projectionCode.match(/^EPSG:(0|null|undefined)?$/)
  ) {
    console.warn(`registerProjection: invalid projection code "${projectionCode}"`);
    return;
  }

  // If projection already exists, skip
  if (getProjection(projectionCode)) {
    return;
  }

  // Try to load from provided allProjs map
  const def = allProjs[projectionCode];
  if (!def) {
    console.warn(`registerProjection: missing projection definition for "${projectionCode}"`);
    return;
  }

  try {
    proj4.defs(projectionCode, def);
    register(proj4);
    console.info(`Projection ${projectionCode} registered successfully.`);
  } catch (err) {
    console.error(`Failed to register projection ${projectionCode}:`, err);
  }
}
